<tec-tile>
    <div class="grid grid grid-e3-sm">
        @for (card of cards; track $index) {
            <tec-card-access
                [title]="card.title"
                [tagImage]="{ icon: card.icon, status: 'default' }"
                size="md"
                (click)="navigateTo(card.route)"
            />
        }
    </div>
</tec-tile>
